module.exports = __webpack_public_path__ + "img/engage.b894a688.png";